export const colorMapping = {
  blue: "#27A8E0",
  orange: "#F05A29",
  yellow: "#FFF204",
  purple: "#652C90",
  green: "#8BC540",
  red: "#EC1B25",
};



// WEBPACK FOOTER //
// ./src/components/UploadPanel/components/TagDropdown/constants.js